
export default {
  name: 'CartVehicles',

  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      working: false,
    }
  },

  computed: {
    vehicles() {
      return this.order?.vehicles || []
    },

    title() {
      return this.vehicles.length > 1
        ? this.$t('components.cartVehicles.titlePlural')
        : this.$t('components.cartVehicles.title')
    },
  },

  methods: {
    nameOf(vehicle) {
      return [vehicle.brand?.name, vehicle.name].filter(Boolean).join(' ')
    },

    yearsOf(vehicle) {
      if (!vehicle.year_from) return null
      return vehicle.year_to
        ? `${vehicle.year_from} - ${vehicle.year_to}`
        : this.$t('components.cartVehicles.yearFrom', {
            yearFrom: vehicle.year_from,
          })
    },

    imageOf(vehicle) {
      return vehicle.image || vehicle.brand?.image || null
    },

    imageSrc(vehicle) {
      const image = this.imageOf(vehicle)
      return this.$cropUrl(image, 40, '_', image.extension, 86)
    },

    imageSrcset(vehicle) {
      const image = this.imageOf(vehicle)
      return [
        `${this.$cropUrl(image, 40, '_', image.extension, 86)} 1x`,
        `${this.$cropUrl(image, 80, '_', image.extension, 86)} 2x`,
      ].join(', ')
    },

    openSelector(replaceVehicleId) {
      if (!this.order?.id) return

      this.$store.dispatch('setVehicleSelectionTarget', {
        orderId: this.order.id,
        replaceVehicleId: replaceVehicleId || null,
      })
      this.$root.$emit('bv::toggle::collapse', 'sidebar-vehicle-selector')
    },

    async removeVehicle(vehicle) {
      if (!this.order?.id || this.working) return

      this.working = true
      try {
        await this.$orderService.removeVehicle(this.order.id, vehicle.id)
        this.$emit('updated')
      } catch (error) {
        this.$swalErrorMessage(error)
      } finally {
        this.working = false
      }
    },
  },
}
